import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.isOpen,
      "max-width": "900"
    },
    on: {
      "close": _vm.closeDialog
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n    " + _vm._s(_vm.$i18n_t('accMgmt.announcement.announcementCreate')) + "\n  ")];
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function () {
        return [_c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-save",
            "disabled": !_vm.formValid
          },
          on: {
            "click": _vm.handleSubmit
          }
        }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Common.save')) + "\n    ")])];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "announcement-edit"
  }, [_c(VForm, {
    ref: "mainForm",
    model: {
      value: _vm.formValid,
      callback: function ($$v) {
        _vm.formValid = $$v;
      },
      expression: "formValid"
    }
  }, [_vm.announcement ? _c(VRow, [_c(VCol, {
    staticClass: "pt-1 pb-2",
    attrs: {
      "cols": "12"
    }
  }, [_c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "py-2",
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c(VSelect, {
    attrs: {
      "label": _vm.$i18n_t('accMgmt.announcement.type'),
      "color": _vm.color,
      "items": ['info', 'warning', 'success', 'error'],
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": ""
    },
    model: {
      value: _vm.announcement.type,
      callback: function ($$v) {
        _vm.$set(_vm.announcement, "type", $$v);
      },
      expression: "announcement.type"
    }
  })], 1), _c(VCol, {
    staticClass: "py-2",
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c(VSelect, {
    attrs: {
      "label": _vm.$i18n_t('accMgmt.announcement.presentationType'),
      "color": _vm.color,
      "items": ['banner', 'message'],
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": ""
    },
    model: {
      value: _vm.announcement.presentationType,
      callback: function ($$v) {
        _vm.$set(_vm.announcement, "presentationType", $$v);
      },
      expression: "announcement.presentationType"
    }
  })], 1), _c(VCol, {
    staticClass: "py-2",
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c(VCheckbox, {
    attrs: {
      "label": _vm.$i18n_t('accMgmt.announcement.includeSubTenants'),
      "color": _vm.color
    },
    model: {
      value: _vm.announcement.includeSubTenants,
      callback: function ($$v) {
        _vm.$set(_vm.announcement, "includeSubTenants", $$v);
      },
      expression: "announcement.includeSubTenants"
    }
  })], 1), _c(VCol, {
    staticClass: "py-2",
    attrs: {
      "cols": "12"
    }
  }, [_c(VTextarea, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('accMgmt.announcement.text'),
      "validate-on-blur": "",
      "hide-details": ""
    },
    on: {
      "keyup": _vm.revalidateForm
    },
    model: {
      value: _vm.announcement.message,
      callback: function ($$v) {
        _vm.$set(_vm.announcement, "message", $$v);
      },
      expression: "announcement.message"
    }
  })], 1)], 1), _c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c(VCheckbox, {
    attrs: {
      "label": _vm.$i18n_t('accMgmt.announcement.useDateRange'),
      "input-value": !!_vm.announcement.start && !!_vm.announcement.end,
      "color": _vm.color,
      "hide-details": ""
    },
    on: {
      "change": _vm.maintenanceToggleDate
    }
  })], 1), _c(VCol, {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "sm": "8"
    }
  }, [!!_vm.announcement.start && !!_vm.announcement.end ? _c('core-date-time-picker', {
    staticClass: "mt-0",
    attrs: {
      "from": _vm.maintenanceDate(_vm.announcement.start),
      "to": _vm.maintenanceDate(_vm.announcement.end),
      "isRange": "",
      "futureRange": ""
    },
    on: {
      "date:picked": _vm.maintenanceDatePicked
    }
  }) : _vm._e()], 1)], 1), _c(VRow, {
    staticClass: "mb-4",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "py-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('h4', {
    staticClass: "mt-0"
  }, [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.announcement.link')))])]), _c(VCol, {
    staticClass: "py-2",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('accMgmt.announcement.url'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": ""
    },
    model: {
      value: _vm.announcement.link.url,
      callback: function ($$v) {
        _vm.$set(_vm.announcement.link, "url", $$v);
      },
      expression: "announcement.link.url"
    }
  })], 1), _c(VCol, {
    staticClass: "py-2",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('accMgmt.announcement.linkText'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": ""
    },
    model: {
      value: _vm.announcement.link.message,
      callback: function ($$v) {
        _vm.$set(_vm.announcement.link, "message", $$v);
      },
      expression: "announcement.link.message"
    }
  })], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };